import {
  CourseAccessTypes,
  CourseItemApiModel,
  CourseItemModel,
  CourseItemProgressApiModel,
  CourseItemProgressModel,
} from './courseItem.model';
import { mapImageResource } from '../../image';
import { customerCourseVendorAdapter } from '../../customer';
import { Nullable } from '../../../models';

const mapCourseAccessType = (
  accessType: number
): Nullable<CourseAccessTypes> => {
  switch (accessType) {
    case 1:
      return CourseAccessTypes.b2c;
    case 2:
      return CourseAccessTypes.b2b;
    default:
      return null;
  }
};

export const mapCourseItem = (course: CourseItemApiModel): CourseItemModel => ({
  uuid: course.id,
  access: {
    accessType: mapCourseAccessType(course.access.access_type),
    isHomeworkAvailable: course.access.is_homework_available,
    corporateAccessDuringEmployment:
      course.access.corporate_access_during_employment,
    subscription: course.access.subscription?.expired_at
      ? {
          expiredAt: course.access.subscription?.expired_at,
        }
      : null,
    trial: course.access.trial?.expired_at
      ? {
          expiredAt: course.access.trial?.expired_at,
        }
      : null,
  },
  email: course.email || null,
  title: course.lms_course.course?.title || course.lms_course.title,
  studyType: course.lms_course.course?.study_type.title || '',
  type: course.lms_course.course?.type || '',
  typeTitle: course.lms_course.course?.type_title || '',
  courseUrl: course.lms_course.course?.url || '',
  courseId: course.lms_course.course?.id || '',
  lmsCourseId: course.lms_course.lms_course_id || '',
  vendorCourseId: course.lms_course.vendor_course_id || '',
  vendor: customerCourseVendorAdapter(course.lms_course.vendor),
  logo: course.lms_course.course?.logo
    ? mapImageResource(course.lms_course.course?.logo)
    : null,
  progress: course?.progress ? mapCourseItemProgress(course.progress) : null,
});

const mapCourseItemProgress = (
  progress: CourseItemProgressApiModel
): CourseItemProgressModel => ({
  progressPercent: progress.progress_percent,
  diplomas: progress.diplomas,
  modules: progress.modules,
  practical: progress.practical,
  tests: progress.tests,
  videos: progress.videos,
  total: progress.total,
});
